import { render, staticRenderFns } from "./ProductionDetail.vue?vue&type=template&id=c4dd3e62"
import script from "./ProductionDetail.vue?vue&type=script&lang=js"
export * from "./ProductionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports